export const aciSurveillanceCamera = {
    iconName: 'surveillance-camera',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2.5 9.824c0-3.038 2.47-5.5 5.512-5.5H21a.5.5 0 01.5.5v2.04a.5.5 0 01-.151.359l-8.182 7.96a.5.5 0 01-.349.141H8.012a5.506 5.506 0 01-5.512-5.5zm5.512-4.5a4.506 4.506 0 00-4.512 4.5c0 2.484 2.02 4.5 4.512 4.5h4.603l7.885-7.67v-1.33H8.012z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M19 8.324a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 110-1h4.5v-4.5a.5.5 0 01.5-.5zM3 15.324a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.642 14.824v4.187a.5.5 0 01-.5.5H3v-1h5.642v-3.687h1z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
